import Popover from "./popover"

export default class extends Popover {
  static targets = ["popover", "trigger"]

  get ariaExpander() {
    return this.triggerTarget
  }
}
